import React, { useMemo } from 'react'
import { useMatchRoute } from '@tanstack/react-router'
import {
  CalendarIcon,
  CircleDashedIcon,
  FileTextIcon,
  TagIcon,
  TagsIcon,
  UploadIcon,
  UsersIcon,
} from 'lucide-react'

type MenuGroup = {
  title?: string | null
  //to: string
  items: Array<MenuItem>
}

type MenuItem = {
  title: string
  to: string
  icon?: React.FC
  meta?: Record<string, unknown>
}

const menu: Array<MenuGroup> = [
  {
    title: 'Documenti',
    items: [
      {
        title: 'Documenti',
        to: '/documents/browse',
        icon: FileTextIcon,
      },
      {
        title: 'In elaborazione',
        to: '/documents/processing',
        icon: CircleDashedIcon,
      },
      {
        title: 'Upload',
        to: '/documents/upload',
        icon: UploadIcon,
      },
      {
        title: 'Calendario',
        to: '/calendar',
        icon: CalendarIcon,
      },
    ],
  },
  {
    title: 'Impostazioni',
    items: [
      {
        title: 'Attributi',
        to: '/settings/attributes',
        icon: TagIcon,
      },
      {
        title: 'Gruppi Attributi',
        to: '/settings/attribute-groups',
        icon: TagsIcon,
      },
      {
        title: 'Utenti',
        to: '/settings/users',
        icon: UsersIcon,
      },
    ],
  },
]

export const useMenu = () => {
  const matchRoute = useMatchRoute()
  const { item, group } = useMemo(() => {
    return menu.reduce(
      (acc, group) => {
        if (acc) return acc

        const item = group.items.find((item) => matchRoute({ to: item.to }))
        if (item) return { item, group }

        return {}
      },
      {} as {
        item?: MenuItem
        group?: MenuGroup
      }
    )
  }, [matchRoute])

  return { menu, activeMenuItem: item, activeMenuGroup: group }
}
